import * as React from 'react';
import { Flex } from "../ViewFrame/Flex";
import styled from "styled-components";

const brokenImage =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMjIgM0gydjE4aDIwdi0yaC0ydjJoMnYtMmgydi0yaC0ydi0yaDJ2LTJoLTJWOWgyVjdoLTJWNWgyVjN6bS0yIDR2MmgtMnYyaDJ2MmgtMnYyaDJ2MmgtMnYySDRWNWgxNHYyaDJ6bS02IDJoLTJ2MmgtMnYySDh2Mkg2djJoMnYtMmgydi0yaDJ2LTJoMnYyaDJ2LTJoLTJWOXpNNiA3aDJ2Mkg2Vjd6IiBmaWxsPSIjMDAwMDAwIi8+Cjwvc3ZnPg==';

const imageCache = new Set<string>();

const Container = styled<any>(Flex)`
  width: ${({ width }) => width ? `${width}px` : '100%'};
  height: ${({ height }) => height ? `${height}px` : '100%'};
`

const StyledImg = styled.img`
  width: 100%;
  height: 100%;
`

const useCache = (src: string) => {
  const [imageSrc, setImageSrc] = React.useState<string>(brokenImage);

  React.useEffect(() => {
    if (!src) return;
    if (imageCache.has(src)) {
      setImageSrc(src);
    } else {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        imageCache.add(src);
        setImageSrc(src);
      };
      img.onerror = () => {
        setImageSrc(brokenImage);
      };
    }
  }, [src]);

  return [imageSrc, setImageSrc] as const;
};

export const LazyImage = ({
  src,
  width,
  height,
  ...props
}: {
  src: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  width?: number;
  height?: number;
}): JSX.Element => {
  const imageRef = React.useRef<HTMLImageElement | null>(null);
  const [imageSrc, setImageSrc] = useCache(src);

  return (
    <Container width={width} height={height}>
      <StyledImg
        ref={imageRef}
        src={imageSrc}
        loading="lazy"
        onError={() => setImageSrc(brokenImage)}
        {...props}
      />
    </Container>
  );
};
